import { useEffect } from 'react';

export function useEventListener(callback) {
    useEffect(
        () => {
            const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            const removeMethod = window.removeEventListener ? "removeEventListener" : "detachEvent";
            const eventer = window[eventMethod];
            const remover = window[removeMethod];
            const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";


            eventer(messageEvent, (ev) => {
                if (
                    ev.origin === `https://${window.location.hostname}` ||
                    ev.origin === `https://twitchingofisaac.com`
                ) {
                    callback(ev.data);
                } else {
                    console.log('Access violation');
                }
            });

            return () => {
                remover(messageEvent, callback);
            };
        }, [callback]
    );
}
